import { useLanguage } from "../lib/i18n";
import { cx } from "../lib/cx";
import { rfqStatusVisual, type RfqStatusTone } from "../lib/rfqStatus";

const DOT: Record<RfqStatusTone, string> = {
  neutral: "bg-[#71717a]",
  primary: "bg-ds-amber",
  warning: "bg-warning",
  success: "bg-success",
  danger: "bg-danger",
};

/**
 * Engine RFQ status (Figma 175:970). A 6px dot plus the EN/TR label.
 * Lost is the only state whose words take the danger colour.
 */
export function RfqStatus({
  status,
  className,
  testId,
}: {
  status: string | null | undefined;
  className?: string;
  testId?: string;
}) {
  const { t } = useLanguage();
  const visual = rfqStatusVisual(status);
  if (!visual) return null;
  const danger = visual.tone === "danger";
  return (
    <span
      className={cx("inline-flex items-center gap-2", className)}
      data-testid={testId}
      data-status={visual.status}
      data-tone={visual.tone}
    >
      <span aria-hidden="true" className={cx("size-1.5 shrink-0 rounded-full", DOT[visual.tone])} />
      <span
        className={cx(
          "font-sans text-[14px] leading-5 font-normal tracking-normal whitespace-nowrap",
          danger ? "text-danger" : "text-[#18181b]",
        )}
      >
        {t(visual.labelKey)}
      </span>
    </span>
  );
}
